// extracted by mini-css-extract-plugin
export default {"root":"LayoutWrapperTopbar_root__FffPQ","absoluteRoot":"LayoutWrapperTopbar_absoluteRoot__NDTAr"};